<template>
  <v-container>
    <v-row class="tw-mt-4">
      <v-col cols="5">
        <label>From: </label>
        <input type="date" v-model="fromDate" />
      </v-col>
      <v-col cols="5">
        <label>To: </label>
        <input type="date" v-model="toDate" />
      </v-col>
      <v-col cols="2">
        <v-btn @click="searchData" color="primary" elevation="2">Search</v-btn>
      </v-col>
    </v-row>
    <v-row class="tw-mt-4">{{ statusMsg }}</v-row>
    <v-row class="tw-mt-4">
      <transaction-table
        :table-data="tableData"
        :rowIds="rowIds"
        :isEditable="true"
      />
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { defineComponent, ref } from "vue";
  import {
    getFirstDateOfMonth,
    getLastDateOfMonth,
    getOneMonthBefore,
  } from "../util/date-util";
  import { Transaction } from "../data-types";
  import { queryDataFromDate, loadQuery } from "../firebase/manageData";

  import TransactionTable from "../components/TransactionTable.vue";

  export default defineComponent({
    name: "TableView",
    components: {
      TransactionTable,
    },
    setup() {
      const tableData = ref<Transaction[]>([]);
      const fromDate = ref<string>(
        getFirstDateOfMonth(getOneMonthBefore(new Date()))
      );
      const toDate = ref<string>(
        getLastDateOfMonth(getOneMonthBefore(new Date()))
      );
      const statusMsg = ref<string>("");
      const rowIds = ref<string[]>([]);
      const selectedItem = ref<string>("");

      const searchData = async () => {
        if (fromDate.value > toDate.value) {
          alert("Invalid Date Range");
          return;
        }
        const query = queryDataFromDate(fromDate.value, toDate.value);
        const loadData = await loadQuery(query);
        tableData.value = loadData.tableData;
        rowIds.value = loadData.rowIds;
        statusMsg.value = loadData.statusMsg;
      };

      return {
        tableData,
        fromDate,
        toDate,
        searchData,
        statusMsg,
        selectedItem,
        rowIds,
      };
    },
  });
</script>
